/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export default function UnmappedFilesTableAction(cellContent, row, rowIndex) {
  return (
    <>
      <OverlayTrigger
        overlay={<Tooltip id="specs-edit-tooltip">Open File Mapper</Tooltip>}
      >
        {
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => {
              if (row.accountId && row.fileUrl) {
                return window.open(
                  "/invoice/" +
                    row.accountId +
                    "/" +
                    row.systemUserType +
                    "/" +
                    row.fileUrl,
                  "_blank"
                );
              }
              return {};
            }}
          >
            {row.accountId && row.fileUrl && (
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Navigation/Sign-in.svg")}
                />
              </span>
            )}
          </a>
        }
      </OverlayTrigger>
    </>
  );
}
